import apiService from '../../../repositories/apiService';

export default {
    getPeople({ commit }) {
        return this.dispatch(
            'People/Pagination/paginatedFetch',
            '/people/viewablePeople',
        )
            .then((response) => {
                commit('setPeople', response.data.data);
            })
            .catch((error) => {
                commit('setError', error);
            });
    },
    getInvitationTable({ commit }, payload = {}) {
        const params = new URLSearchParams();

        if (payload.filters) {
            Object.entries(payload.filters).forEach(([key, value]) => {
                if (value !== null && value !== '') {
                    // Map frontend filter names to backend parameter names
                    let paramName = key;
                    if (key === 'receivedGp') paramName = 'receivedGp';
                    if (key === 'receivedHc') paramName = 'receivedHc';
                    if (key === 'gpResponse') paramName = 'gpResponse';
                    if (key === 'hcResponse') paramName = 'hcResponse';
                    if (key === 'involvement') paramName = 'involvement';
                    params.append(paramName, value);
                }
            });
        }
        if (payload.locationId) {
            params.append('locationId', payload.locationId);
        }

        // Date filters
        if (payload.gpDateFrom) {
            params.append('gp_date_from', payload.gpDateFrom);
        }
        if (payload.gpDateTo) {
            params.append('gp_date_to', payload.gpDateTo);
        }
        if (payload.hcDateFrom) {
            params.append('hc_date_from', payload.hcDateFrom);
        }
        if (payload.hcDateTo) {
            params.append('hc_date_to', payload.hcDateTo);
        }

        // Sorting parameters
        if (payload.sortBy) {
            params.append('sort_by', payload.sortBy);
        }
        if (payload.sortOrder) {
            params.append('sort_order', payload.sortOrder);
        }

        // Note: search parameter is handled by paginatedFetch automatically from state.searchQuery
        const baseUrl = '/people/invitation_table';
        const urlWithParams = params.toString() ? `${baseUrl}?${params.toString()}` : baseUrl;

        return this.dispatch(
            'People/Pagination/paginatedFetch',
            urlWithParams
        )
            .then((response) => {
                commit('setPeople', response.data.data);
            })
            .catch((error) => {
                commit('setError', error);
            });
    },
    getPersonById(state, payload) {
        return new Promise((resolve, reject) => {
            apiService.get(
                `/people/${payload.personId}`
            )
                .then((response) => {
                    state.commit('setPerson', response.data.data);
                    resolve(response);
                })
                .catch((error) => {
                    state.commit('setError', error);
                    reject(error);
                });
        });
    },
    updatePerson(state, payload) {
        return new Promise((resolve, reject) => {
            apiService
                .put(`/people/${payload.person_id}`, payload)
                .then((response) => {
                    // state.commit('setPerson', response.data.data);
                    resolve(response.data.person_id);
                })
                .catch((error) => {
                    state.commit('setError', error);
                    reject(error);
                });
        });
    },
    getGenders(state) {
        return new Promise((resolve, reject) => {
            apiService
                .get('/list_items/genders')
                .then((response) => {
                    state.commit('setGenders', response.data);
                })
                .catch((error) => {
                    state.commit('setError', error);
                });
        });
    },
    getSchoolYears(state) {
        return new Promise((resolve, reject) => {
            apiService
                .get('/list_items/schoolYears')
                .then((response) => {
                    state.commit('setSchoolYears', response.data);
                })
                .catch((error) => {
                    state.commit('setError', error);
                });
        });
    },
    getLocations(state) {
        return new Promise((resolve, reject) => {
            apiService
                .get('/locations/focus')
                .then((response) => {
                    state.commit('setLocations', response.data);
                })
                .catch((error) => {
                    state.commit('setError', error);
                });
        });
    },
    getRoles(state) {
        return new Promise((resolve, reject) => {
            apiService
                .get('/roles')
                .then((response) => {
                    state.commit('setRoles', response.data);
                })
                .catch((error) => {
                    state.commit('setError', error);
                });
        });
    },
    storePerson(state, payload) {
        return new Promise((resolve, reject) => {
            apiService
                .post('/people', payload)
                .then((response) => {
                    resolve(response.data.person_id);
                })
                .catch((error) => {
                    state.commit('setError', error);
                    reject(error);
                });
        });
    },
};
